import Chart from 'chart.js/auto';
import enterView from 'enter-view';

Alpine.data('pieChart', (defaultSelectedCategory, categories) => {
	let chart;

	return {
		categoryType: defaultSelectedCategory ?? '',
		categories,

		init() {
			enterView({
				selector: [this.$root],
				once: true,
				offset: 0.5,
				enter: () => {
					this.initialiseChart(this.categoryType);
				},
			});
		},
		initialiseChart(selectedCategory) {
			const pieChart = this.$refs.chart;
			const ctx = pieChart.querySelector('canvas');
			const defaultPieChartData = this.categories.find(
				(cat) => cat.category_name_short === selectedCategory
			);
			const pieData = defaultPieChartData.stat_list;
			const labels = pieData.map((e) => e.stat_name);
			const percentages = pieData.map((e) => e.stat_percentage);
			const colors = pieData.map((e) => e.stat_colour);

			const data = {
				labels,
				datasets: [
					{
						data: percentages,
						backgroundColor: colors,
						borderColor: colors,
						rotation: 200,
					},
				],
			};

			chart = new Chart(ctx, {
				type: 'doughnut',
				data,
				options: {
					plugins: {
						legend: {
							display: false,
						},
						tooltip: {
							enabled: false, // Disable tooltips
						},
					},
					elements: {
						arc: {
							// Custom the default hover effects
							borderWidth: 1,
							borderColor: '#fff',
							hoverBorderWidth: 0, // Disable border width change on hover
							hoverBorderColor: '#000', // Disable border color change on hover
							hoverBackgroundColor: null, // Disable background color change on hover
						},
					},
					hover: {
						mode: null, // Disable hover effects
					},
				},
			});
		},
		updateChart(newCategory) {
			const newPieChartData = this.categories.find(
				(cat) => cat.category_name_short === newCategory
			);

			if (newPieChartData) {
				const pieData = newPieChartData.stat_list;
				const labels = pieData.map((e) => e.stat_name);
				const percentages = pieData.map((e) => parseFloat(e.stat_percentage)); // Ensure percentages are numbers
				const colors = pieData.map((e) => e.stat_colour);

				if (chart) {
					// Update chart data
					chart.data.labels = labels;
					chart.data.datasets[0] = {
						data: percentages,
						backgroundColor: colors,
						borderColor: colors,
						rotation: 200,
					};

					// Update chart to apply changes
					chart.update();
				} else {
					console.error('Chart instance is not initialized');
				}
			} else {
				console.error('Category not found');
			}
		},
		setCategoryType(category) {
			this.categoryType = category;
			this.updateChart(category);
		},
		getActiveCategory(category) {
			return category === this.categoryType;
		},
	};
});
